import { Building2 } from 'lucide-react';
import { useOrganizationStore } from '@/store/organizationStore';
import { cn } from '@/lib/utils';

interface OrganizationNameProps {
  collapsed?: boolean;
}

/**
 * T2459 — ime organizacije uporabnika v stranski vrstici.
 *
 * Do T2459 je bil tu izbirnik organizacij (`OrganizationSelector`). Po pravilu
 * ene organizacije (T2456) je uporabnik aktiven član samo ene, zato ni česa
 * izbirati; sodelovanje z drugimi organizacijami poteka kot zunanji sodelavec
 * na projektu, kjer projekt sam nosi organizacijo gostiteljice
 * (`project.organization_slug`). Prikaz je zato statičen.
 */
export default function OrganizationName({ collapsed = false }: OrganizationNameProps) {
  const currentOrganization = useOrganizationStore((s) => s.currentOrganization);

  if (!currentOrganization) return null;

  return (
    <div
      title={currentOrganization.name}
      data-testid="sidebar-organization-name"
      className={cn(
        'flex items-center rounded-md text-foreground w-full',
        collapsed ? 'justify-center p-2' : 'gap-2 px-3 py-1.5',
      )}
    >
      <Building2 className="h-4 w-4 text-muted-foreground shrink-0" aria-hidden="true" />
      {!collapsed && (
        <span className="text-body font-medium truncate">{currentOrganization.name}</span>
      )}
      {collapsed && <span className="sr-only">{currentOrganization.name}</span>}
    </div>
  );
}
